import { useIntl } from 'react-intl';

import { SignUpForm } from '../../../features/auth';

import ContourBackdrop from '../../../components/ContourBackdrop/ContourBackdrop';

import introImg from '../../../shared/assets/illustrations/auth-preview.png';

import styles from './sign-up-page.module.css';

export const SignUpPage = () => {
	const intl = useIntl();

	return (
		<div className={styles.container}>
			<ContourBackdrop className={styles.contoursLeft} rings={8} from={1.6} />
			<ContourBackdrop className={styles.contoursRight} rings={6} from={2.2} />

			<div className={styles.panels}>
				<aside className={styles.intro}>
					<h1 className={styles.welcome}>
						{intl.formatMessage({ id: 'AuthId1' })}
					</h1>
					<p className={styles.introText}>
						{intl.formatMessage({ id: 'AuthId2' })}
					</p>
					<img className={styles.introImage} src={introImg} alt='' />
				</aside>

				<div className={styles.formSlot}>
					<SignUpForm />
				</div>
			</div>
		</div>
	);
};
